import { Grid, Link, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { AssessmentAndSubmissionResponse } from "../../../redux/Assessment/assessmentApis";
import DownloadFileChip from "./DownloadFileChip";
import OpenURLChip from "./OpenURLChip";

type Props = {
  assessmentDetails?: AssessmentAndSubmissionResponse;
};

const linkify = (text: string) => {
  var urlRegex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  console.log(text);
  return text?.split(urlRegex).map((part) => {
    if (part.match(urlRegex)) {
      return (
        <Link href={part} target="_blank">
          {part}
        </Link>
      );
    }
    return <Typography variant="body1">{part}</Typography>;
  });
};

const AssessmentInfo = ({ assessmentDetails }: Props) => {
  return (
    <Grid container item direction={"column"} gap={2} my={2}>
      <Grid container item direction={"column"} gap={1}>
        <Typography fontSize={"14px"} lineHeight={"20px"} fontWeight={"500"}>
          Assessment guidelines and rules
        </Typography>
        {linkify(assessmentDetails?.assessmentGuideline || "")}
      </Grid>
      {assessmentDetails?.attachmentList.length ? (
        <Grid container item direction={"column"} gap={1}>
          <Typography fontSize={"14px"} lineHeight={"20px"} fontWeight={"500"}>
            Attachments
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
            {assessmentDetails?.attachmentList.map((name) => (
              <DownloadFileChip name={name} key={name} />
            ))}
          </Stack>
        </Grid>
      ) : null}
      {assessmentDetails?.urlList.length ? (
        <Grid container item direction={"column"} gap={1}>
          <Typography fontSize={"14px"} lineHeight={"20px"} fontWeight={"500"}>
            URL/s
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
            {assessmentDetails?.urlList.map((url) => (
              <OpenURLChip url={url} key={url} />
            ))}
          </Stack>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default AssessmentInfo;
